import React from 'react'
import { IItemBebidaInterface } from '../data/bebida';
import { IItemInterface } from '../data/dataInterface';
import { ProductMinimoConPrecio } from './ProductMinimoConPrecio';

interface Props {
    items: IItemBebidaInterface[];
}
export const ProductListMinimoConPrecio = ({items} : Props) => {
  return (
    <div className="flex flex-row justify-content-start flex-wrap">
        {items.map((item: IItemBebidaInterface) => {
            return <ProductMinimoConPrecio 
                        indicator={item.indicator}
                        name={item.name}
                        description={item.description}
                        image={item.image}
                        alergenos={item.alergenos} 
                        picante={item.picante}
                        precio={item.precio}
                        key={item.indicator+item.name}/>
        })}
    </div>
  )
}
